
export const REQUEST_GET_VIDEOS = 'video/REQUEST_GET_VIDEOS';
export const REQUEST_SEARCH_VIDEO = 'video/REQUEST_SEARCH_VIDEO';
